import {Member} from "@/models/member";
import {Card} from "@/components/ui/card";
import {Badge} from "@/components/ui/badge";
import {CoinsIcon, PhoneIcon, UserIcon} from "lucide-react";
import {generateCompleteMemberName} from "@/services/member-services.ts";

interface MemberInfoCardProps {
    member: Member;
    showPoints?: boolean;
}

// FIXME i18n, address generation, layouting
function MemberInfoCard({member, showPoints = false}: MemberInfoCardProps) {
    return (
        <Card className="p-4 overflow-hidden">
            <div className="flex items-start gap-4">
                <div className="bg-blue-100 dark:bg-blue-950 rounded-full p-3">
                    <UserIcon className="h-6 w-6 text-blue-600 dark:text-blue-400"/>
                </div>
                <div className="flex-1 min-w-0">
                    <div className="flex items-baseline justify-between mb-1">
                        <h3 className="text-base font-semibold truncate">
                            {generateCompleteMemberName(member)}
                        </h3>
                        <Badge variant="outline" className="ml-2 whitespace-nowrap">
                            Nr. {member.memberNo}
                        </Badge>
                    </div>

                    <p className="text-sm text-gray-600 dark:text-gray-400 truncate mb-1">
                        {member.address?.street} {member.address?.houseNumber}, {member.address?.postcode} {member.address?.city}
                    </p>

                    {member.phoneNumbers && member.phoneNumbers.length > 0 && (
                        <div className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                            <span className="flex items-center gap-1.5">
                                <PhoneIcon className="h-3.5 w-3.5"/>
                                {member.phoneNumbers[0].number}
                            </span>
                        </div>
                    )}

                    {showPoints && member.memberPoints && (
                        <div className="mt-2 flex items-center gap-1">
                            <CoinsIcon className="h-4 w-4 text-amber-500"/>
                            <span className="text-sm font-medium">
                                {member.memberPoints.points} Punkte
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
}

export default MemberInfoCard;
